import { render, staticRenderFns } from "./BirthInfinite.vue?vue&type=template&id=cedd28d2"
import script from "./BirthInfinite.vue?vue&type=script&lang=js"
export * from "./BirthInfinite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports